import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ source = "hero", variant = "dark", testid = "waitlist" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email, source });
      setDone(true);
      setEmail("");
      toast.success("You're on the list.", {
        description: "We'll send your early-access invite soon.",
      });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong. Try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const light = variant === "light";

  return (
    <form
      onSubmit={submit}
      data-testid={`${testid}-form`}
      className={`flex w-full max-w-md items-center gap-2 rounded-full border p-1.5 pl-5 transition-colors ${
        light
          ? "border-ink/20 bg-white/70 focus-within:border-ink"
          : "border-textMuted/25 bg-surface/80 backdrop-blur-md focus-within:border-aqua"
      }`}
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`${testid}-input`}
        className={`min-w-0 flex-1 bg-transparent text-sm outline-none placeholder:text-textMuted/70 ${
          light ? "text-ink" : "text-textMain"
        }`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`${testid}-submit`}
        className="group flex shrink-0 items-center gap-1.5 rounded-full bg-aqua px-5 py-3 text-sm font-bold text-ink transition-transform duration-200 hover:scale-[1.03] hover:bg-aquaHover disabled:opacity-60"
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : done ? (
          "Joined"
        ) : (
          <>
            Get early access
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
          </>
        )}
      </button>
    </form>
  );
};
